var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isProduction)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"alert alert-dark",attrs:{"role":"alert"}},[_c('pre',[_c('code',[_vm._v(_vm._s(_vm.dump))])])])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }